import React, { Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import MainTable from "../components/main-tables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import {
  customer_receivable_isFirst,
  list_customer_receivable,
} from "../../redux/sap-master/customer-recivable";
import { useSelector } from "react-redux";
import { addGroupDataData } from "../../redux/sap-master/group-master-active-data-reducer";
import {
  addCustomerDataData,
  clearCustomerDataData,
} from "../../redux/sap-master/customer-recivable-active-data";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from "@mui/icons-material/Search";
import { Button, InputAdornment, TextField } from "@mui/material";
import {
  sink_customer_receivable_isSuccess,
  sink_customer_receivable_master,
} from "../../redux/sap-master/sink-customer-receivable";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";
const CustomerReceivables = () => {
  const dispatch = useDispatch();
  const [activePartner, setActivePartner] = React.useState<null | number>(null);
  const activeDatas = useSelector(
    (state: any) => state.CustomerReceivableActiveData
  );
  const [search, setSearch] = useState<string>("");
  const activeData = activeDatas.data;
  const customer_receivable_data = useSelector(
    (state: any) => state.CustomerReceivable
  );
  const sinkCustomerReceivableApi = useSelector(
    (state: any) => state.SinkCustomerReceivableMaster
  );
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();
  // useEffect
  useEffect(() => {
    dispatch(list_customer_receivable(""));
    if (sinkCustomerReceivableApi.isSuccess) {
      dispatch(sink_customer_receivable_isSuccess(""));
    }
  }, [sinkCustomerReceivableApi]);

  const handleBack = () => {
    dispatch(clearCustomerDataData());
    setActivePartner(null);
    setShowBack(false);
    setTitleContext("Customer Receivables");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearCustomerDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.AcctName) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.AcctName ?? "Customer Receivables");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    const filterarr = [];
    for (let i = 0; i < customer_receivable_data.data.data.length; i++) {
      let data = { ...customer_receivable_data.data.data[i] };
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // create on
      const created_on = new Date(data.created_on);
      // delete data.EffecDate;
      const created_date =
        created_on.getDate() +
        "-" +
        monthNames[created_on.getMonth()] +
        "-" +
        created_on.getFullYear();
      data.created_on
        ? (data.created_on = created_date)
        : console.log("sdfdsf");

      // update on
      const updated_on = new Date(data.updated_on);
      // delete data.EffecDate;
      const update_date =
        updated_on.getDate() +
        "-" +
        monthNames[updated_on.getMonth()] +
        "-" +
        updated_on.getFullYear();
      data.updated_on ? (data.updated_on = update_date) : console.log("sdfdsf");

      filterarr.push(data);
    }
    filterarr.filter((e) => delete e.id);
    filterarr.filter((e) => delete e.active);
    filterarr.filter((e) => delete e.created_by);
    filterarr.filter((e) => delete e.updated_by);
    console.log(activeData);
    return (
      <Fragment>
        <div className="content_container">
          <div
            className={`mini_side_container`}
            style={{
              display:
                isMobile && typeof activePartner === "number"
                  ? "none"
                  : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              Customer Receivables
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(sink_customer_receivable_master(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (customer_receivable_data.isFirst && key === 0) {
                    dispatch(customer_receivable_isFirst(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addCustomerDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          activePartner === key ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.AcctName}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.AcctCode}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display:
                isMobile && typeof activePartner !== "number"
                  ? "none"
                  : "initial",
            }}
          >
            {typeof activePartner !== "number" ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One Customer Receivable
              </div>
            ) : (
              <div className="scroll_content_container scroll_content_container_2">
                <div className="grid_container">
                  <div className="detail_item">
                    <label className="f4">Acct Name</label>
                    <p>{activeData.AcctName}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Acct Code</label>
                    <p>{activeData.AcctCode}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Group Mask</label>
                    <p>{activeData.GroupMask}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Levels</label>
                    <p>{activeData.Levels}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Create On</label>
                    <p>{activeData.created_on}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Update On</label>
                    <p>{activeData.updated_on}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <div className="partner-details">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={customer_receivable_data.isLoading ? true : false}
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
        {/* <div className="title d-flex">
          <h5>Customer Receivables</h5>
          <div className="ms-auto me-2">
            <FontAwesomeIcon
              onClick={() => {
                dispatch(list_customer_receivable(""));
              }}
              style={{
                fontSize: "22px",
                cursor: "pointer",
              }}
              icon={["fas", "arrows-rotate"]}
            />
          </div>
        </div> */}
        {customer_receivable_data.isSuccess ? (
          mainTable()
        ) : (
          <div className="not_found_container">
            <img src={DataNotFound} alt="" />
            No Data Found
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CustomerReceivables;
